module.exports = __webpack_public_path__ + "static/Datanara-29149d411127d237a2dcfc2a7b2571d7.jpg";